import { IManufacturer } from '@models/Manufacturer.model';

import ReactDom from 'react-dom';

import { State } from '@hookstate/core';

import { useState as classicUseState } from 'react';
import { Icon as BlueIcon } from '@blueprintjs/core';

import FormControlLabel from '@material-ui/core/FormControlLabel';

import CheckBox from '@assets/svg/checkbox.svg';

import { withStyles } from '@material-ui/core';
import { blue } from '@material-ui/core/colors';
import Checkbox, { CheckboxProps } from '@material-ui/core/Checkbox';

import { useMutation, useQueryClient } from 'react-query';

import { addContact } from '@services/queries/contact/addContactNew/addContact';

import { useParams } from 'react-router-dom';
import { useFieldArray, useForm } from 'react-hook-form';
import {
  AssociateText,
  GlobalHeader,
  CheckCircle,
  Label,
  RowDiv,
  UncheckCircle,
  Input,
  Container,
  Bottom,
  BottomText,
  Cancel,
  Confirm,
  Close2,
  Header2,
  Title,
  Overlay,
  Divider,
  AddButton,
  IconContainer,
  Row,
  ColumnDiv,
  Body,
} from './AddContacts.styles';

const BlueCheckbox = withStyles({
  root: {
    color: blue[300],
    '&$checked': {
      color: blue,
    },
  },
  checked: {},
})((props: CheckboxProps) => <Checkbox color="default" {...props} />);
interface ContactProps {
  manufacturerData?: IManufacturer;
  openAddContact: State<boolean>;
}

interface IForm {
  phones: Array<{ phone: string; label: string }>;
  emails: Array<{ email: string; label: string }>;
  name: string;
  title: string;
}
/**
 * # Note
 *  This should only be called with a manufacturer (and product), else it may create unintended data. See mutationAddContact.mutate
 */
const AddContacts = ({ manufacturerData, openAddContact }: ContactProps) => {
  const portalDiv = document.getElementById('portal');

  const params = useParams<{ equipmentId: string }>();

  const queryClient = useQueryClient();

  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { isValid },
  } = useForm<IForm>({
    defaultValues: {
      phones: [{ phone: '', label: '' }],
      emails: [{ email: '', label: '' }],
      name: '',
      title: '',
    },
    reValidateMode: 'onChange',
  });
  const phonesField = useFieldArray({
    control,
    name: 'phones',
  });
  const emailsField = useFieldArray({
    control,
    name: 'emails',
  });

  const [associateTo, setAssociateTo] = classicUseState<
    'product' | 'manufacturer' | 'global'
  >('manufacturer');

  const [firstPhone, setFirstPhone] = classicUseState<string>('');
  const [firstEmail, setFirstEmail] = classicUseState<string>('');

  const clearStates = () => {
    reset();
    setFirstPhone('');
    setFirstEmail('');
    setAssociateTo('manufacturer');
  };

  const mutationAddContact = useMutation(addContact, {
    onSuccess: () => {
      clearStates();
      openAddContact.set(false);
      queryClient.invalidateQueries([
        'equipments',
        params.equipmentId,
        'contacts',
      ]);
    },
  });

  const onSubmit = (formData: IForm) => {
    if (!mutationAddContact.isLoading) {
      mutationAddContact.mutate({
        data: {
          manufacturerId:
            associateTo === 'manufacturer' ? manufacturerData?.id : undefined,
          haveOwnerStudio: true,
          title: formData.title,
          isGlobal: associateTo === 'global',
          name: formData.name,
          phones: formData.phones.filter(phone => !!phone.phone),
          emails: formData.emails.filter(email => !!email.email),
        },
      });
    }
  };

  if (!manufacturerData) return <div>Manufacturer info missing</div>;

  return openAddContact.get() && portalDiv
    ? ReactDom.createPortal(
        <Overlay>
          <Container>
            <Header2>
              <Title>Add Contact</Title>
              <Close2
                onClick={() => {
                  openAddContact.set(false);
                  clearStates();
                  setAssociateTo('manufacturer');
                }}
              >
                <BlueIcon icon="cross" color="#8f95b2" />
              </Close2>
            </Header2>
            <Body>
              <form onSubmit={handleSubmit(onSubmit)} id="addContactForm">
                <Label>Contact Name</Label>
                <Divider height="8px" />
                <Input
                  {...register('name')}
                  required
                  placeholder="EX: Local Service Contact"
                  autoFocus
                />

                <Divider height="16px" />

                <Label className="labelOptional">Title (Optional)</Label>
                <Divider height="8px" />
                <Input
                  {...register('title')}
                  placeholder="EX: Local Service Contact"
                />

                <Divider height="16px" />
                <Row>
                  <ColumnDiv>
                    <Label>Phone Number</Label>
                    <Divider height="8px" />
                  </ColumnDiv>
                  <ColumnDiv>
                    <Label className="labelOptional">
                      Number Label (Optional)
                    </Label>
                    <Divider height="8px" />
                  </ColumnDiv>
                </Row>

                {phonesField.fields.map((field, index) => (
                  <Row key={field.id}>
                    <ColumnDiv>
                      {index !== 0 && <Divider height="16px" />}
                      <Input
                        key={field.id}
                        {...register(`phones.${index}.phone`)}
                        onChange={e => {
                          register(`phones.${index}.phone`).onChange(e);
                          if (index === 0) {
                            setFirstPhone(e.target.value);
                          }
                        }}
                        type="tel"
                        pattern="[^a-zA-Z@]+$"
                        required={index === 0 && !firstEmail && !firstPhone}
                        placeholder="EX: 999-999-9999"
                      />
                    </ColumnDiv>
                    <ColumnDiv>
                      {index !== 0 && <Divider height="16px" />}
                      <Input
                        key={field.id}
                        {...register(`phones.${index}.label`)}
                        placeholder="EX: Work Contact"
                      />
                    </ColumnDiv>
                  </Row>
                ))}

                <Divider height="16px" />

                <AddButton
                  type="button"
                  onClick={() => {
                    phonesField.append({ phone: '', label: '' });
                  }}
                >
                  <IconContainer>
                    <BlueIcon icon="plus" color="#8f95b2" />
                  </IconContainer>
                </AddButton>

                <Divider height="16px" />

                <Row>
                  <ColumnDiv>
                    <Label>Email</Label>
                    <Divider height="8px" />
                  </ColumnDiv>
                  <ColumnDiv>
                    <Label className="labelOptional">
                      Email Label (Optional)
                    </Label>
                    <Divider height="8px" />
                  </ColumnDiv>
                </Row>

                {emailsField.fields.map((field, index) => (
                  <Row key={field.id}>
                    <ColumnDiv>
                      {index !== 0 && <Divider height="16px" />}
                      <Input
                        key={field.id}
                        {...register(`emails.${index}.email`)}
                        onChange={e => {
                          register(`emails.${index}.email`).onChange(e);
                          if (index === 0) {
                            setFirstEmail(e.target.value);
                          }
                        }}
                        type="email"
                        pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                        required={index === 0 && !firstEmail && !firstPhone}
                        placeholder="EX: contact@contact.com"
                      />
                    </ColumnDiv>
                    <ColumnDiv>
                      {index !== 0 && <Divider height="16px" />}
                      <Input
                        key={field.id}
                        {...register(`emails.${index}.label`)}
                        placeholder="EX: Main Address"
                      />
                    </ColumnDiv>
                  </Row>
                ))}

                <Divider height="16px" />

                <AddButton
                  type="button"
                  onClick={() => {
                    emailsField.append({ email: '', label: '' });
                  }}
                >
                  <IconContainer>
                    <BlueIcon icon="plus" color="#8f95b2" />
                  </IconContainer>
                </AddButton>

                <Divider height="16px" />

                <GlobalHeader>Associate to</GlobalHeader>
                <div
                  style={{
                    flexDirection: 'row',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    marginBottom: 8,
                    width: '100%',
                  }}
                >
                  <RowDiv>
                    <FormControlLabel
                      style={{ margin: 0 }}
                      control={
                        <BlueCheckbox
                          icon={<UncheckCircle />}
                          checkedIcon={
                            <CheckCircle src={CheckBox} alt="CheckBox" />
                          }
                          name="checkedH"
                        />
                      }
                      label=""
                      checked={associateTo === 'manufacturer'}
                      onClick={() => setAssociateTo('manufacturer')}
                    />
                    <Label>Manufacturer</Label>
                  </RowDiv>
                  <RowDiv>
                    <FormControlLabel
                      style={{ margin: 0 }}
                      control={
                        <BlueCheckbox
                          icon={<UncheckCircle />}
                          checkedIcon={
                            <CheckCircle src={CheckBox} alt="CheckBox" />
                          }
                          name="checkedH"
                        />
                      }
                      label=""
                      checked={associateTo === 'global'}
                      onClick={() => setAssociateTo('global')}
                    />
                    <Label>Global Contact</Label>
                  </RowDiv>
                </div>
                {associateTo === 'global' && (
                  <AssociateText>
                    This contact will be available for any product or
                    manufacturer.
                  </AssociateText>
                )}
                {associateTo === 'manufacturer' && (
                  <AssociateText>
                    {`This contact will be visible on assets related to ${manufacturerData?.name} products.`}
                  </AssociateText>
                )}

                {associateTo === 'product' && (
                  <AssociateText>
                    This contact will be available for any of the selected
                    product.
                  </AssociateText>
                )}
                {(associateTo === 'global' ||
                  associateTo === 'manufacturer') && (
                  <div style={{ height: '100%' }} />
                )}
              </form>
            </Body>

            <Bottom>
              <BottomText>
                Tip: At least one Phone Number or Email need to be added, but
                having both is not required.
              </BottomText>
              <Cancel onClick={clearStates} type="button">
                Clear
              </Cancel>
              <Divider width="8px" />
              <Confirm
                type="submit"
                form="addContactForm"
                disabled={!isValid || mutationAddContact.isLoading}
              >
                Add
              </Confirm>
            </Bottom>
          </Container>
        </Overlay>,
        portalDiv,
      )
    : null;
};

export { AddContacts };
